<div id="pwd-dialog">
  <h2 mat-dialog-title id="pwd-dialog-title">{{ this.title }}</h2>
  <div mat-dialog-content>
    <mat-form-field class="pwd-dialog-input" id="path-dialog-input" [hidden]="isHidden">
      <mat-label>Path</mat-label>
      <input matInput [(ngModel)]="path" type="text" placeholder="Enter your Path" required>
    </mat-form-field>
    <br />
    <mat-form-field class="pwd-dialog-input" >
      <mat-label>Password</mat-label>
      <input matInput [(ngModel)]="password" type="password" placeholder="Enter your Password" required>
    </mat-form-field>
    <div *ngIf="loading" class="loading-spinner">
      <mat-spinner diameter="30"></mat-spinner>
    </div>
  </div>
  <div mat-dialog-actions id="pwd-dialog-actions">
    <button mat-button (click)="onNoClick()" [disabled]="loading">Cancel</button>
    <button mat-button (click)="submitPassword()" [disabled]="loading">Submit</button>
  </div>
</div>

<script>
  if (global === undefined) {
    var global = window;
  }
</script>
